import React from 'react'
import { Accordion, AccordionDetails, AccordionSummary } from 'components/Shared/Accordion'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    padding: 0,
    maxWidth: 'fit-content',
    display: 'inline'
  },
  content: {
    margin: 0,
    display: 'inherit',
    '&$expanded': {
      margin: 0
    }
  },
  expanded: {
    minHeight: '0 !important'
  }
})

export function AdditionalDetailsCollapse ({ children, title }) {
  const internalStyles = useStyles()

  return (
    <Accordion isScrolling={false} isExpandedOnStart={true}>
      <AccordionSummary
        classes={internalStyles}>
        {title}
      </AccordionSummary>
      {children && <AccordionDetails classes={{ root: internalStyles.root }}>
        {children}
      </AccordionDetails>}
    </Accordion>
  )
}
